var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMainIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_65254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6417 9.42853H13.356C12.9221 9.42853 12.5703 9.78031 12.5703 10.2142V19.6428C12.5703 20.0767 12.9221 20.4285 13.356 20.4285H19.6417C20.0756 20.4285 20.4275 20.0767 20.4275 19.6428V10.2142C20.4275 9.78031 20.0756 9.42853 19.6417 9.42853Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6417 1.57141H13.356C12.9221 1.57141 12.5703 1.92319 12.5703 2.35713V5.5157C12.5703 5.94963 12.9221 6.30141 13.356 6.30141H19.6417C20.0756 6.30141 20.4275 5.94963 20.4275 5.5157V2.35713C20.4275 1.92319 20.0756 1.57141 19.6417 1.57141Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64174 1.57141H2.35603C1.92209 1.57141 1.57031 1.92319 1.57031 2.35713V11.7857C1.57031 12.2196 1.92209 12.5714 2.35603 12.5714H8.64174C9.07568 12.5714 9.42746 12.2196 9.42746 11.7857V2.35713C9.42746 1.92319 9.07568 1.57141 8.64174 1.57141Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64174 15.6985H2.35603C1.92209 15.6985 1.57031 16.0502 1.57031 16.4843V19.6428C1.57031 20.0767 1.92209 20.4286 2.35603 20.4286H8.64174C9.07568 20.4286 9.42746 20.0767 9.42746 19.6428V16.4843C9.42746 16.0502 9.07568 15.6985 8.64174 15.6985Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMainIcon);
export default __webpack_public_path__ + "static/media/DashboardMainIcon.3fa50f67a0590e2cd10d0f5e8a1660d3.svg";
export { ForwardRef as ReactComponent };